import { reactive } from 'vue';

import { StListI } from '@/support/interfaces';
import { StT } from '@/support/types';

type StateType = {
  sts?: StListI;
  selectedToken?: StT;
  selectedSmsKey?: StT;
  selectedEok?: StT;
  selectedEpin?: StT;
  owfeTokenDataResponse: {};

  removeRename: {
    renameOld: String;
    renameNew: String;
    remove: String;
  };
};

const state = reactive<StateType>({
  sts: undefined,
  selectedToken: undefined,
  selectedSmsKey: undefined,
  selectedEok: undefined,
  selectedEpin: undefined,
  owfeTokenDataResponse: {},

  removeRename: {
    renameOld: '',
    renameNew: '',
    remove: '',
  },
});

export default state;
